import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {NotificationComponent} from './notification.component';

const routes: Routes = [
    {
        path: 'notifications',
        component: NotificationComponent,
        data: {animation: 'notifications'}
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class NotificationRoutingModule {
}
